import { Inbox } from 'lucide-react';
import { useT } from '../i18n';
import { ActivationChecklist } from './ActivationChecklist';

export function InboxEmpty() {
  const t = useT();
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 p-6">
      {/* ANX-067 — онбординг-чеклист активации (сам прячется, когда всё готово). */}
      <ActivationChecklist />
      <div className="max-w-sm text-center">
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-accent-50 text-accent-600">
          <Inbox size={22} aria-hidden="true" />
        </div>
        <h2 className="text-base font-semibold text-slate-900">{t('inbox.empty.title')}</h2>
        <p className="mt-1 text-sm text-slate-500">{t('inbox.empty.hint')}</p>
      </div>
    </div>
  );
}
